import styled from "@emotion/styled";
import type { To } from "react-router-dom";
import { Button, FlexRow, H3, IconArrow, Link } from "atoms";
import { useNavigate } from "react-router-dom";
import { scrollToHash } from "utils/scroll";

const NAV_ID = "navigation";

interface JumpNavItem {
  id: string;
  label: string;
}

interface JumpNavProps {
  items: JumpNavItem[];
}

function JumpNav({ items }: JumpNavProps) {
  return (
    <Nav id={NAV_ID}>
      <H3 size="sm">Jump to section:</H3>

      <SFlexRow>
        {items.map(({ id, label }) => (
          <li key={id}>
            <JumpNavLink to={`#${id}`}>{label}</JumpNavLink>
          </li>
        ))}
      </SFlexRow>
    </Nav>
  );
}

function BackToTop() {
  return (
    <Link to={`#${NAV_ID}`}>
      Back to top
      <IconArrow dir="u" />
    </Link>
  );
}

interface GoToButtonProps {
  to: To;
  children: React.ReactNode;
}

function JumpNavLink({ to, children }: GoToButtonProps) {
  const navigate = useNavigate();

  const onClick = () => {
    navigate(to);
    scrollToHash();
  };

  return (
    <Button variant="primary" onClick={onClick}>
      {children}
    </Button>
  );
}

const Nav = styled.nav(({ theme }) => ({
  fontSize: theme.fontSizes.h3,
  margin: "2rem 0",
  textAlign: "center",
  h3: {
    marginBottom: "1rem",
  },
  button: {
    background: "none",
    fontSize: theme.fontSizes.xs,
    minHeight: "1em",
    padding: ".4em .6em",
    textTransform: "none",
    svg: {
      display: "none",
    },
  },
}));

const SFlexRow = styled(FlexRow)({
  gap: "10px",
  justifyContent: "center",
  listStyleType: "none",
  margin: 0,
  padding: 0,
  li: {
    flex: "0 0 auto",
  },
}).withComponent("ul");

export { JumpNav, BackToTop };
